import { Injectable } from '@angular/core';
import { ConfigurationModule } from '../../configuration.module';
import { RefreshTokenConfiguration } from './refresh-token-configuration';

@Injectable({
  providedIn: ConfigurationModule
})
export class RefreshTokenConfigurationService {

  configuration: RefreshTokenConfiguration;

  constructor() { }

  loadConfiguration(configuration) {
    configuration = {
      enabled: false,
      storeRefreshTokens: false
    }
    this.configuration = configuration;
  }
}
